import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { DownOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import ReactLoading from "react-loading";
import { useReactToPrint } from "react-to-print";


import "./Buttons.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
function BtnPrint({ 
  label,
  size, 
  divId, 
  fileName 
}) {
  const [isClicked, setIsClicked] = useState(false);
  const items = [
    {
      label: 'A5',
      key: 'a5',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'A4',
      key: 'a4',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'Letter',
      key: 'letter',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'Legal',
      key: 'legal',
      icon: <PaperClipOutlined />,
    },
  ];
  const reactToPrint = useReactToPrint({
    content: () => divId.current,
  });

  const handlePrint = async (e) => {
    setIsClicked(true);
    const input = divId.current;
    // const input = document.getElementById(divId);
    const padding = 0;
    html2canvas(input).then((canvas) => {     
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', e?.key, true);
      const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * padding;
      const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * padding;
  
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
  
      const ratioWidth = pdfWidth / imgWidth;
      const ratioHeight = pdfHeight / imgHeight;
      const ratio = Math.min(ratioWidth, ratioHeight);
  
      const finalImgWidth = imgWidth * ratio;
  
      const imgX = padding + (pdfWidth - finalImgWidth) / 2;
      let imgY = 5;
  
      pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      // Save pdf file locally
      // pdf.save(fileName);
      // pdf.autoPrint();
      reactToPrint()
      // pdf.output("dataurlnewwindow");
    });
    setIsClicked(false);
  };
  

  const menuProps = {
    items,
    onClick: (e) => handlePrint(e),
  };

  return (
    <Col>
      {isClicked ? (
        <Button className="action-btn clear loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#2d6e5e" />
        </Button>
      ) : (
        <Dropdown menu={menuProps}>
          <Button className="action-btn clear" size={size}>
              {label}
              <DownOutlined />
          </Button>
        </Dropdown>
      )}
    </Col>
  );
}

export default BtnPrint;

